import { Notification } from "../domain/Notification";
import { NotificationRepository } from "../domain/NotificationRepository";

export class UserNotificationsQuery {
  constructor(
    private readonly noti_repo: NotificationRepository,
  ) {}

  execute(): Promise<{ [key: string]: Notification[] | string[]; }> {
    return this.noti_repo.get_data();
  }
}

